import { sectionRenderer } from '@theme/section-renderer';
import { StandardEvents } from '@shopify/events';

const SECTION = 'cart-drawer-section';
const PROT = 'shipping-protection';
const KEY = 'hzProtOptOut';
const SEEN = 'hzSeen';
let busy = false;
let emptyTicks = 0;

try { localStorage.removeItem(KEY); } catch (e) {}
function optedOut() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
function setOpt(v) { try { v ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {} }

async function refresh() {
  try { await sectionRenderer.renderSection(SECTION, { cache: false, mode: 'hydration' }); } catch (e) { console.warn('cart refresh failed', e); }
}

async function post(url, body) {
  const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  if (!r.ok) console.warn('cart request failed', url, r.status);
  return r;
}

/* ---------- header cart bubble: never counts the protection line ---------- */
async function syncBubble() {
  try {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const c = await r.json();
    const real = c.items.filter((i) => i.handle !== PROT).reduce((s, i) => s + i.quantity, 0);
    document.querySelectorAll('cart-icon').forEach((ic) => { if (typeof ic.renderCartBubble === 'function') ic.renderCartBubble(real, false); });
    const prot = c.items.find((i) => i.handle === PROT);
    if (real === 0 && prot && !busy) {
      busy = true;
      try { await post('/cart/change.js', { id: prot.key, quantity: 0 }); await refresh(); } finally { busy = false; }
      document.querySelectorAll('cart-icon').forEach((ic) => { if (typeof ic.renderCartBubble === 'function') ic.renderCartBubble(0, false); });
    }
  } catch (e) {}
}

async function setProtection(box, on) {
  if (busy) return;
  busy = true;
  try {
    if (on) await post('/cart/add.js', { id: Number(box.dataset.variant), quantity: 1 });
    else if (box.dataset.key) await post('/cart/change.js', { id: box.dataset.key, quantity: 0 });
    await refresh();
  } finally { busy = false; }
  syncBubble();
}

function autoAdd() {
  const box = document.querySelector('[data-prot-box]');
  if (!box || busy) return;
  if (box.dataset.orphan === '1' && box.dataset.key) { setProtection(box, false); return; }
  if (optedOut()) return;
  if (box.dataset.needs === '1' && !window.__cartProtTried) {
    window.__cartProtTried = true;
    setProtection(box, true).finally(() => { setTimeout(() => { window.__cartProtTried = false; }, 2000); });
  }
}

function drawer() { const c = document.querySelector('cart-drawer-component'); return c ? c.closest('theme-drawer') : null; }

/* gives other scripts a working open() on the drawer element */
function shim() {
  const c = document.querySelector('cart-drawer-component');
  if (c && typeof c.open !== 'function') c.open = function () { const d = drawer(); if (d && !d.isOpen && typeof d.open === 'function') d.open(); };
}

/* ---------- scarcity line: goes on the line that was added to the cart FIRST ----------
   Each line gets a first-seen timestamp (kept in this browser). The oldest line carries the message;
   when it is removed the next oldest takes over. */
function seenMap() { try { return JSON.parse(localStorage.getItem(SEEN) || '{}') || {}; } catch (e) { return {}; } }
function oldestRow(rows) {
  const m = seenMap();
  const keys = rows.map((r) => r.dataset.key);
  let changed = false;
  Object.keys(m).forEach((k) => { if (keys.indexOf(k) < 0) { delete m[k]; changed = true; } });
  const now = Date.now();
  let n = 0;
  for (let i = rows.length - 1; i >= 0; i--) {
    const k = rows[i].dataset.key;
    if (!m[k]) { m[k] = now + n++; changed = true; }
  }
  if (changed) { try { localStorage.setItem(SEEN, JSON.stringify(m)); } catch (e) {} }
  let best = rows[0];
  rows.forEach((r) => { if (m[r.dataset.key] <= m[best.dataset.key]) best = r; });
  return best;
}

function fast() {
  try {
    const box = document.querySelector('[data-prot-box]');
    const txt = box ? box.dataset.fast : 'Selling fast';
    const rows = Array.from(document.querySelectorAll('.cart-drawer__items tr.cart-items__table-row')).filter((r) => !r.classList.contains('cart-items__nested-line') && r.dataset.key && getComputedStyle(r).display !== 'none');
    if (!rows.length) {
      /* cart looks empty: forget the order only after it stays empty for a moment (avoids wiping it mid re-render) */
      emptyTicks++;
      if (emptyTicks >= 3) { try { localStorage.removeItem(SEEN); } catch (e) {} }
    } else { emptyTicks = 0; }
    const first = txt && rows.length ? oldestRow(rows) : null;
    document.querySelectorAll('.cart-drawer__items .hzf').forEach((el) => { if (!first || !first.contains(el)) el.remove(); });
    if (!first) return;
    const have = first.querySelector('.hzf');
    if (have) {
      const b = have.querySelector('b');
      if (b && b.textContent !== txt) b.textContent = txt;
      return;
    }
    const host = first.querySelector('.cart-items__variants-wrapper') || first.querySelector('.cart-items__product-info') || first.querySelector('.cart-items__details');
    if (!host) return;
    const d = document.createElement('p');
    d.className = 'hzf';
    const dot = document.createElement('span');
    dot.className = 'hzf__dot';
    dot.textContent = '●';
    const b = document.createElement('b');
    b.textContent = txt;
    d.append(dot, b);
    host.appendChild(d);
  } catch (e) {}
}

function heading() {
  const box = document.querySelector('[data-prot-box]');
  const h = document.querySelector('.cu__heading');
  if (box && h && box.dataset.upsellHeading && h.textContent !== box.dataset.upsellHeading) h.textContent = box.dataset.upsellHeading;
}

/* ---------- cart upsell: arrows + quick-add panel ---------- */
function arrows() {
  document.querySelectorAll('[data-cu]').forEach((root) => {
    const track = root.querySelector('[data-cu-track]');
    const prev = root.querySelector('.cu__arrow--prev');
    const next = root.querySelector('.cu__arrow--next');
    if (!track || !prev || !next) return;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  });
}
document.addEventListener('scroll', (e) => { if (e.target && e.target.matches && e.target.matches('[data-cu-track]')) arrows(); }, true);

let pdata = null, psel = [], pbusy = false;
function panel() {
  let p = document.querySelector('.cupq');
  if (p) return p;
  const c = document.querySelector('cart-drawer-component');
  const dlg = c && c.closest('dialog');
  if (!dlg) return null;
  p = document.createElement('div');
  p.className = 'cupq';
  p.innerHTML = `<div class='cupq__head'><p class='cupq__htitle'></p><button type='button' class='cupq__close' data-cupq-close aria-label='Close'></button></div><div class='cupq__body'><img class='cupq__img' alt=''><p class='cupq__title'></p><p class='cupq__price'></p><div class='cupq__options'></div><p class='cupq__error' role='alert' hidden></p><button type='button' class='cupq__add'>Add to cart</button><a class='cupq__details' href='#'>View full details</a></div>`;
  dlg.appendChild(p);
  return p;
}
function pcurrent() { return (pdata.variants.find((v) => v.o.every((x, k) => x === psel[k]))) || null; }
function pavail(idx, val) { return pdata.variants.some((v) => v.a && v.o[idx] === val && v.o.every((x, k) => k === idx || x === psel[k])); }
function prender() {
  const p = panel();
  const q = (s) => p.querySelector(s);
  const v = pcurrent();
  q('.cupq__htitle').textContent = pdata.title;
  q('.cupq__title').textContent = pdata.title;
  q('.cupq__details').setAttribute('href', pdata.url);
  const idx = v && v.m >= 0 ? v.m : 0;
  const img = pdata.images[idx] || pdata.images[0];
  if (img) q('.cupq__img').setAttribute('src', img);
  const price = q('.cupq__price');
  price.textContent = '';
  if (v) {
    if (v.c) { const s = document.createElement('s'); s.textContent = v.c; price.appendChild(s); }
    const n = document.createElement('span');
    n.textContent = v.p;
    if (v.c) n.className = 'is-sale';
    price.appendChild(n);
  }
  const wrap = q('.cupq__options');
  wrap.textContent = '';
  if (pdata.variants.length > 1) {
    pdata.options.forEach((name, i) => {
      const g = document.createElement('div');
      g.className = 'cupq__opt';
      const l = document.createElement('p');
      l.className = 'cupq__label';
      l.textContent = name + ': ';
      const sp = document.createElement('span');
      sp.textContent = psel[i];
      l.appendChild(sp);
      const vals = document.createElement('div');
      vals.className = 'cupq__vals';
      const seen = {};
      pdata.variants.forEach((variant) => {
        const val = variant.o[i];
        if (seen[val]) return;
        seen[val] = 1;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cupq__val' + (psel[i] === val ? ' is-selected' : '') + (pavail(i, val) ? '' : ' is-unavailable');
        b.textContent = val;
        b.dataset.i = i;
        b.dataset.v = val;
        vals.appendChild(b);
      });
      g.append(l, vals);
      wrap.appendChild(g);
    });
  }
  const add = q('.cupq__add');
  add.disabled = pbusy || !(v && v.a);
  add.textContent = pbusy ? 'Adding...' : (v ? (v.a ? 'Add to cart' : 'Sold out') : 'Unavailable');
}
function popen(d) {
  const p = panel();
  if (!p) return;
  pdata = d;
  const start = d.variants.find((v) => v.a) || d.variants[0];
  psel = start.o.slice();
  pbusy = false;
  p.querySelector('.cupq__error').hidden = true;
  prender();
  requestAnimationFrame(() => p.classList.add('is-open'));
}
function pclose() { const p = document.querySelector('.cupq'); if (p) p.classList.remove('is-open'); }
async function padd() {
  const v = pcurrent();
  if (!v || !v.a || pbusy) return;
  pbusy = true;
  prender();
  const err = document.querySelector('.cupq__error');
  err.hidden = true;
  try {
    const r = await post('/cart/add.js', { items: [{ id: v.i, quantity: 1 }] });
    const j = await r.json();
    pbusy = false;
    if (!r.ok || j.status) { err.textContent = j.description || j.message || 'Could not add this item.'; err.hidden = false; prender(); return; }
    pclose();
    await refresh();
    syncBubble();
  } catch (e) { pbusy = false; err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; prender(); }
}

document.addEventListener('click', async (e) => {
  const out = e.target.closest('[data-prot-optout]');
  if (out) {
    const box = document.querySelector('[data-prot-box]');
    setOpt(true);
    if (box && box.dataset.key) { try { await post('/cart/change.js', { id: box.dataset.key, quantity: 0 }); } catch (err) {} }
    window.location.href = '/checkout';
    return;
  }
  const plus = e.target.closest('[data-cu-plus]');
  if (plus) {
    const card = plus.closest('.cu__card');
    const raw = card && card.querySelector('[data-cu-data]');
    if (!raw) return;
    try { popen(JSON.parse(raw.textContent)); } catch (err) { window.location.href = card.querySelector('.cu__title').href; }
    return;
  }
  const sc = e.target.closest('[data-cu-scroll]');
  if (sc) {
    const track = sc.closest('[data-cu]').querySelector('[data-cu-track]');
    track.scrollBy({ left: Number(sc.dataset.cuScroll) * track.clientWidth * 0.9, behavior: 'smooth' });
    return;
  }
  if (e.target.closest('[data-cupq-close]')) { pclose(); return; }
  const val = e.target.closest('.cupq__val');
  if (val) { psel[Number(val.dataset.i)] = val.dataset.v; prender(); return; }
  if (e.target.closest('.cupq__add')) padd();
});

/* the header count follows every cart change, minus the protection line */
document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
  const go = () => { setTimeout(syncBubble, 30); setTimeout(fast, 80); setTimeout(fast, 400); };
  if (e.promise && typeof e.promise.then === 'function') e.promise.then(go, go); else go();
});

let t;
function tick() { shim(); fast(); heading(); autoAdd(); arrows(); }
const host = document.getElementById('cart-drawer');
if (host) new MutationObserver(() => { clearTimeout(t); t = setTimeout(tick, 40); }).observe(host, { childList: true, subtree: true });
setTimeout(tick, 200);
/* safety net: the drawer can be re-rendered without notice, so re-check the cheap bits twice a second */
setInterval(() => { if (!document.hidden) { fast(); heading(); } }, 500);

/* correct the server-rendered header count once per page (protection line is not an item) */
setTimeout(() => {
  const el = document.querySelector('cart-icon [ref="cartBubbleCount"]');
  if (el && parseInt(el.textContent, 10) > 0) syncBubble();
}, 600);
